import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.10822 11.1616H5.0026C3.02035 11.1616 1.45435 11.1616 1.45435 10.1543V9.94694C1.45435 8.02019 3.04585 6.45306 5.0026 6.45306H7.10822C9.06497 6.45306 10.6568 8.02056 10.6568 9.94694V10.1543C10.6568 11.1616 9.01247 11.1616 7.10822 11.1616ZM5.95022 6.18644C4.40072 6.18644 3.13997 4.94406 3.13997 3.41744C3.13997 1.89081 4.40072 0.648438 5.95022 0.648438C7.49972 0.648438 8.76047 1.89044 8.76047 3.41744C8.76047 4.94444 7.49972 6.18644 5.95022 6.18644Z"
      fill="#6B767C"
    />
  </svg>
);
export default SVGComponent;
